import React from 'react';

interface TaskNotesProps {
  notes: string;
}

export function TaskNotes({ notes }: TaskNotesProps) {
  if (!notes) return null;

  return (
    <div className="mt-3 sm:mt-4 p-3 sm:p-5 bg-gradient-to-br from-amber-50 to-amber-100/50 dark:from-amber-900/20 dark:to-amber-800/20 rounded-xl sm:rounded-xl border border-amber-100/50 dark:border-amber-800/30 shadow-sm">
      <h4 className="text-sm sm:text-sm font-medium text-amber-800 dark:text-amber-300 mb-2.5 sm:mb-3 flex items-center gap-2 sm:gap-2">
        <span className="text-lg">📝</span>
        <span>Notes</span>
      </h4>
      <div
        className="prose prose-sm dark:prose-invert max-w-none text-amber-700 dark:text-amber-300"
        dangerouslySetInnerHTML={{ __html: notes }}
      />
    </div>
  );
}